module.exports = __webpack_public_path__ + "img/smart_o_m.5c60d767.gif";